module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-fm"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_vm._v("C"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#cpyntc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraphs"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Epigraphs")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct-top"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NE: ")]), _vm._v("M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EET THE ")]), _vm._v("P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IPERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#map1"
    }
  }, [_vm._v("Map of Indian Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("WO: ")]), _vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE ")]), _vm._v("K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ING OF ")]), _vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PICES")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#map2"
    }
  }, [_vm._v("Map of the Middle East and India")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HREE: ")]), _vm._v("D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RUGS AND ")]), _vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OULS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Sumatra")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OUR: ")]), _vm._v("G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OLDEN ")]), _vm._v("E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LEPHANTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Southeast Asia and the East Indies")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IVE: ")]), _vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE ")]), _vm._v("B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RITISH ")]), _vm._v("I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NVADE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IX: ")]), _vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE ")]), _vm._v("D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UTCH ")]), _vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ERROR")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Pepper Coast of Northern Sumatra")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EVEN: ")]), _vm._v("U"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v(".")]), _vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v(". ")]), _vm._v("P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EPPER ")]), _vm._v("F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORTUNES")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IGHT: ")]), _vm._v("A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("N ")]), _vm._v("I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NFINITE ")]), _vm._v("N"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UMBER OF ")]), _vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("INE: ")]), _vm._v("M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EDICINAL ")]), _vm._v("P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EPPER")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epil",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#nts",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Photo1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#abt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0